<!-- Page to assign expert to an open ticket-->
<!-- Verifying Moderator Role -->
<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>

<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper ">
    <div>
      <div class="content">
        <ng-container *ngIf="notAssignedTickets">
          <div class="alert alert-primary" role="alert" *ngIf="notAssignedTickets.length !== 0">
            Tickets To Be Assigned
          </div>
          <div class="alert alert-danger" role="alert" *ngIf="notAssignedTickets.length === 0">
            No Tickets to Assign
          </div>
          <!-- list of open tickets -->
          <div class="card">
            <div class="card-body">
          <table class="table table-hover" *ngIf="notAssignedTickets.length !== 0">
            <thead class=" text-primary">
              <tr>
                <th scope="col">Ticket ID</th>
                <th scope="col">Customer</th>
                <th scope="col">Message</th>
                <th scope="col">Created On</th>
                <th scope="col" >View Experts</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ticket of notAssignedTickets; let i = index">
                <td>{{ ticket._id }}</td>
                <td>{{ ticket.customer.fullName }}</td>
                <td>
                  <div *ngIf="ticket.message[0]">{{ ticket.message[0]['message'] }}</div>
                  <div *ngIf="!ticket.message[0]">NO MESSAGE TO DISPLAY</div>
                </td>
                <td>{{ ticket.createdAt }}</td>
                <td>
                  <button type="button" class="btn btn-outline-primary" (click) ="open(mymodal,ticket)">Assign expert</button>
                  <!-- <button type="button" class="btn btn-outline-primary" data-toggle="modal" data-target=".bd-example-modal-xl">Get All Experts</button> -->
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #mymodal let-modal>
            <div class="modal-header">
              <h4 class="modal-title" id="modal-basic-title">Available SNAM Experts</h4>
              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <!-- Expert details -->
              <div class="modal-body">
                <ng-container *ngIf="experts">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">Expert ID</th>
                          <th scope="col">User Name</th>
                          <th scope="col">Full Name</th>
                          <th scope="col">Email ID</th>
                          <th scope="col">Contact Number</th>
                          <th scope="col">Assign this Expert</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let expert of experts">
                          <td>{{ expert._id }}</td>
                          <td>{{ expert.userName }}</td>
                          <td>{{ expert.fullName }}</td>
                          <td id="email">{{ expert.email }}</td>
                          <td>{{ expert.contactNumber }}</td>
                          <td>
                            <button type="button" class="btn btn-outline-primary" (click)="assignExpert(expert)">
                              Assign Expert
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
              </div>
              <div class="modal-footer">
                Please Select one of the available experts
              </div>
          </ng-template>

        </div>
      </div>
        </ng-container>
        <ng-container *ngIf="assignedTickets">
          <div class="alert alert-danger" role="alert" *ngIf="assignedTickets.length === 0">
            No Assigned Tickets
          </div>
          <div class="alert alert-primary" role="alert" *ngIf="assignedTickets.length !== 0">
            Tickets Assigned
          </div>
          <div class="card">
            <div class="card-body">
          <table class="table table-hover" *ngIf="assignedTickets.length !== 0">
            <thead class=" text-primary">
              <tr>
                <th scope="col">Ticket ID</th>
                <th scope="col">Customer</th>
                <th scope="col">Tech Expert</th>
                <th scope="col">Message</th>
                <th scope="col">See Conversation</th>
                <th scope="col">Created On</th>
                <th scope="col">CLOSE Ticket</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ticket of assignedTickets">
                <td>{{ ticket._id }}</td>
                <td>{{ ticket.customer.fullName }}</td>
                <td>{{ ticket.techExpert.fullName }}</td>
                <td>
                  <div *ngIf="ticket.message[0]">{{ ticket.message[0]['message'] }}</div>
                  <div *ngIf="!ticket.message[0]">NO MESSAGE TO DISPLAY</div>
                </td>
                <td>
                  <button class="btn btn-lg btn-outline-primary" (click)="openChat(mychatmodal, ticket.message, ticket._id)">See Chat</button>
                </td>

                <td>{{ ticket.createdAt }}</td>
                <td><button type="button" class="btn btn-outline-primary" (click) = "closeTicket(ticket._id)">Close Ticket</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
        </ng-container>
        <!-- List of Closed tickets-->
        <ng-container *ngIf="closedTickets">
          <div class="alert alert-danger" role="alert" *ngIf="closedTickets.length === 0">
            No Closed Tickets
          </div>
          <div class="alert alert-primary" role="alert" *ngIf="closedTickets.length !== 0">
            Closed Tickets
          </div>
          <div class="card">
            <div class="card-body">
          <table class="table table-hover" *ngIf="closedTickets.length !== 0">
            <thead class=" text-primary">
              <tr>
                <th scope="col">Ticket ID</th>
                <th scope="col">Customer</th>
                <th scope="col">Tech Expert</th>
                <th scope="col">Message</th>
                <th scope="col">See Conversation</th>
                <th scope="col">Created On</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ticket of closedTickets">
                <td>{{ ticket._id }}</td>
                <td *ngIf="ticket.customer">{{ ticket.customer.fullName }}</td>
                <td *ngIf="!ticket.customer">Details unavailable</td>
                <td>
                  <div *ngIf="ticket.techExpert">
                    {{ ticket.techExpert.fullName }}
                  </div>
                </td>
                <td>{{ ticket.message[0]['message'] }}</td>
                <td>
                  <button class="btn btn-lg btn-outline-primary" (click)="openChat(mychatmodal, ticket.message, ticket._id)">See Chat</button>
                </td>
                <td>{{ ticket.createdAt }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
        </ng-container>

        
        <ng-template #mychatmodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">See the chat with expert and customer</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>






            <div class="modal-body">

              <div id="container">
                <main>
                  <ul id="chat">
                    <div *ngFor='let message of messages'>
                      <div *ngIf="message.verified === true">
                        <div *ngIf="message.role === 'TECHEXPERT'">
                          <li class="you">
                            <div class="entete">
                              <span class="status green"></span>
                              <h2>Expert</h2>
                              <h3> | {{transformDate(message.createdAt)}}</h3>
                            </div>
                            <div class="triangle"></div>
                            <div class="message">
                              {{message.message}}
                            </div>
                          </li>
                        </div>
                        <div *ngIf="message.role === 'CUSTOMER'">
                          <li class="me">
                            <div class="entete">
                              <h3>{{transformDate(message.createdAt)}} | </h3>
                              <h2>Customer</h2>
                              <span class="status blue"></span>
                            </div>
                            <div class="triangle"></div>
                            <div class="message">
                              {{message.message}}
                            </div>
                          </li>
                        </div>
                      </div>

                    </div>
                  </ul>
                  <footer>
                    <!-- <textarea [(ngModel)]="customerMessage" placeholder="Type your message" required></textarea>
                    <a (click)="replyToTicket()"><button [disabled]="!customerMessage">Send</button></a> -->
                  </footer>
                </main>
              </div>
            </div>





            <!--Add Image-->
            <div class="modal-footer">
              Your communication is not end-to-end encrypted
            </div>
        </ng-template>
      </div>
    </div>
  </div>

</ng-container>
<!-- end of ticket assignment-->
